import type { Customer, ProductFeature } from "../state/customer";
import { useCustomerState } from "../state/customer";
import { initialized } from "../utils/initializedUtil";

let customerStore: Customer | null = null;

const getCustomerStore = () => initialized(customerStore, "customerStore");

const init = () => {
  customerStore = useCustomerState();
};

const FeatureService = {
  init,
  hasFeature: (feature: ProductFeature) => getCustomerStore().unlockedFeatures.includes(feature),
};

export default FeatureService;
